// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cg_share_menu,\n.cg_share_menu .v-list,\n.cg_share_menu .v-select-list {\n\tbackground: #171921 !important;\n}\n.cg_share_menu {\n\tborder: 1px solid #4A4A4A !important;\n}\n.cg_share_menu .v-list-item,\n.cg_share_menu .v-list-item__content,\n.cg_share_menu .v-list-item__title {\n\tcolor: white !important;\n}\n", ""]);
// Exports
module.exports = exports;
